import React from "react";
import States from "../../containers/state";
import { Layout } from "antd";
import "./styles.css";
// import Navbar from '../../components/navbar';
const { Footer, Content } = Layout;

function index(props) {
  return (
    <div>
      <Layout>
        <Content>
          <States props={props} />
        </Content>
        <Footer>Footer</Footer>
      </Layout>
    </div>
  );
}

export default index;
